import { styled } from "@mui/material";
const Scroller = styled("div", {
  name: "ScrollbarScroller",
  shouldForwardProp: (prop) => prop !== "hideOverflow",
  slot: "Scroller"
})((props) => ({
  position: "relative",
  display: "block",
  width: "100%",
  overflowX: props.hideOverflow === "x" ? "hidden" : "auto",
  overflowY: props.hideOverflow === "y" ? "hidden" : "auto",
  "&::-webkit-scrollbar-track": {
    opacity: 0,
    background: "rgba(222, 222, 222, .75)"
  },
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    opacity: 0
  },
  "&::-webkit-scrollbar-thumb": {
    opacity: 0,
    borderRadius: "10px",
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  }
}));
export {
  Scroller
};
//# sourceMappingURL=Scroller.js.map
